module.exports = __webpack_public_path__ + "static/media/ThankYou.9070bf72.jpg";